import React, { useEffect, useState } from "react";
import TagService from "../../services/KangarooServices/TagService";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useNavigate, useParams } from "react-router-dom";
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";

const TagDetail = () => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const fetchDetail = async (id) => {
    try {
      const result = await TagService.getbyId(id);
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDetail(id);
  }, [id]);

  
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Details"
          pageTitle="Tags"
          breadcrumbItems={[{ title: "Back to List", link: "/tag" }]}
        />
        {loading ? (
          <div className="text-center py-5">
            <Spinner color="primary" />
          </div>
        ) : (
          <Row>
            <Col lg={12}>
              <Card className="shadow-sm mt-1 border-0 p-0">
                <CardHeader
                  className="bg-gradient text-white border-0"
                  style={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  }}
                >
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-tag-fill me-2"></i>
                    Tag Details
                  </h5>
                </CardHeader>

                <CardBody className="p-4">
                  {/* <Row className="mb-3 align-items-center">
          <Col md="4">
            <strong className="text-secondary">ID:</strong>
          </Col>
          <Col md="8">
            <span className="text-muted font-monospace">{data.id}</span>
          </Col>
        </Row> */}

                  <hr className="my-3" style={{ opacity: 0.1 }} />

                  <Row className="mb-3 align-items-center">
                    <Col md="4">
                      <strong className="text-secondary">Name:</strong>
                    </Col>
                    <Col md="8">
                      <Badge
                        color="info"
                        pill
                        className="px-3 py-2"
                        style={{ fontSize: "0.9rem" }}
                      >
                        {data.name}
                      </Badge>
                    </Col>
                  </Row>

                  <hr className="my-3" style={{ opacity: 0.1 }} />

                  <Row className="mb-3 align-items-center">
                    <Col md="4">
                      <strong className="text-secondary">
                        Blog Tag Count:
                      </strong>
                    </Col>
                    <Col md="8">
                      <span className="badge bg-light text-dark border px-3 py-2">
                        {data.blogTagCount}
                      </span>
                    </Col>
                  </Row>

                  <hr className="my-3" style={{ opacity: 0.1 }} />

                  <Row className="mb-3 align-items-center">
                    <Col md="4">
                      <strong className="text-secondary">
                        Page Tag Count:
                      </strong>
                    </Col>
                    <Col md="8">
                      <span className="badge bg-light text-dark border px-3 py-2">
                        {data.pageTagCount}
                      </span>
                    </Col>
                  </Row>

                  <hr className="my-3" style={{ opacity: 0.1 }} />

                  <Row className="mb-3 align-items-center">
                    <Col md="4">
                      <strong className="text-secondary">Created At:</strong>
                    </Col>
                    <Col md="8">
                      <span className="text-muted">
                        <i className="bi bi-calendar-check me-2"></i>
                        {new Date(data.createdAt).toLocaleString()}
                      </span>
                    </Col>
                  </Row>

                  <hr className="my-3" style={{ opacity: 0.1 }} />

                  <Row className="align-items-center">
                    <Col md="4">
                      <strong className="text-secondary">Updated At:</strong>
                    </Col>
                    <Col md="8">
                      <span className="text-muted">
                        <i className="bi bi-calendar-event me-2"></i>
                        {data.updatedAt
                          ? new Date(data.updatedAt).toLocaleString()
                          : "Not updated yet"}
                      </span>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};

export default TagDetail;
